import { useEffect, useState, useCallback } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Flowchart from "flowchart-react";
import useApp from '../AppContext';
import {
  ErrorAlert
} from '../crud/utils';

import { DataComponentWrapper } from '../crud/DataComponentWrapper';
import CrudForm from '../crud/CrudForm';

export default function RfFlowDesigner(props) {
  const [error, setError] = useState(null);
  const [objUnderEdit, setObjUnderEdit] = useState(null);
  const [objToDesign, setObjToDesign] = useState(null);
  const [listProps, setListProps] = useState({});
  const [initialFormLayout, setInitialFormLayout] = useState(null);
  const [formLayout, setFormLayout] = useState(null);
  const app = useApp();
  const language = app.sessionToken?.Language;
  const [setNodes] = useState([]);
  const [setConns] = useState([]);

  const listRowSelected = useCallback((layoutId, row, listProps) => {
    if (!listProps || !listProps.dataContext) return;
    if (row && listProps && listProps.dataContext) {
      let formLayout = { ...listProps.dataContext.getFormLayout('RfFlows') };
      listProps.dataContext.beginEdit('RfFlows', row);
      setListProps(listProps);
      setInitialFormLayout({ ...formLayout });
    }
  }, []);

  const onObjUnderEditChanged = useCallback((objUnderEdit) => {
    setObjUnderEdit(objUnderEdit);
    if (!objUnderEdit || !objUnderEdit['RfFlows'] || !objUnderEdit['RfFlows'].current) return;
    setObjToDesign(objUnderEdit['RfFlows'].current);
  }, []);


  useEffect(() => {
    if (!objUnderEdit || !objUnderEdit['RfFlows'] || !objUnderEdit['RfFlows'].current || !initialFormLayout) return;
    const r = objUnderEdit['RfFlows'].current;
    initialFormLayout.tabs = initialFormLayout.tabs.filter((l) => {
      if (l.caption === "Γενικά") {
        return true;
      } else if (r.RfFlowType === 1) {
        return l.caption === "Εντολές συλλογής";
      } else {
        return false;
      }
    });
    setFormLayout(initialFormLayout);
  }, [initialFormLayout, objUnderEdit]);

  function createEdit() {
    if (!objUnderEdit) return null;
    if (!formLayout) return null;
    if (!listProps || !listProps.dataContext) return null;
    return <CrudForm
      dataContext={listProps.dataContext}
      userToken={props.userToken}
      layout={formLayout}
      objUnderEdit={objUnderEdit['RfFlows']}
      active={true} isStandAlone={true}
      onChange={(obj) => setObjToDesign({ ...obj })} />
  }

  function createFlowChart() {
    if (!objToDesign) return;
    const r = objToDesign;
    let nodes = [];
    let conns = [];
    if (r.RfFlowType === 1) {
      let y = 40;
      let id = 0;
      nodes.push({
        type: "start",
        title: "Start of Picking",
        x: 40,
        y: y,
        id: id,
      });

      let pickingType = "Order";
      if (r.PickingRequestType === '2') {
        pickingType = "Order Group";
      } else if (r.PickingRequestType === '3') {
        pickingType = "Pre-cubed Package";
      }

      if (r.ZoneRequestFlg) {
        nodes.push({
          title: "Zone Selection",
          type: "operation",
          x: 240,
          y: y,
          id: 10,
        });
      }

      y += 100;
      id++;
      nodes.push({
        title: r.AutoAssignFlg ? pickingType + " Auto Assignment" : "Scan of " + pickingType,
        type: "operation",
        x: 40,
        y: y,
        id: id,
      });

      y += 100;
      id++;
      nodes.push({
        title: "Task Display",
        type: "operation",
        x: 40,
        y: y,
        id: id,
      });

      y += 100;
      id++;
      nodes.push({
        title: "Item Scan",
        type: "operation",
        x: 40,
        y: y,
        id: id,
      });

      if (r.QtyEntryType && r.QtyEntryType !== '4') {
        let lu = 'LU1 ';
        if (r.QtyEntryType === '2') lu = "LU2";
        else if (r.QtyEntryType === '3') lu = "LU2 & LU1";
        nodes.push({
          title: lu + " entry",
          type: "operation",
          x: 240,
          y: y,
          id: 11,
        });
      }

      y += 100;
      id++;
      nodes.push({
        title: "End of Order",
        type: "decision",
        x: 40,
        y: y,
        id: id,
      });

      y += 100;
      id++;
      nodes.push({
        type: "end",
        title: "End",
        x: 40,
        y: y,
        id: id,
      });

      if (r.ZoneRequestFlg) {
        conns.push({
          source: { id: 0, position: "right" },
          destination: { id: 10, position: "left" }
        });
        conns.push({
          source: { id: 10, position: "bottom" },
          destination: { id: 1, position: "right" }
        });
      } else {
        conns.push({
          source: { id: 0, position: "bottom" },
          destination: { id: 1, position: "top" }
        });
      }

      if (r.QtyEntryType && r.QtyEntryType !== '4') {
        conns.push({
          source: { id: 3, position: "right" },
          destination: { id: 11, position: "left" }
        });
        conns.push({
          source: { id: 11, position: "bottom" },
          destination: { id: 4, position: "right" }
        });
      } else {
        conns.push({
          source: { id: 3, position: "bottom" },
          destination: { id: 4, position: "top" }
        });
      }

      conns.push({
        source: { id: 1, position: "bottom" },
        destination: { id: 2, position: "top" }
      });
      conns.push({
        source: { id: 2, position: "bottom" },
        destination: { id: 3, position: "top" }
      });
      conns.push({
        source: { id: 4, position: "bottom" },
        destination: { id: 5, position: "top" }
      });
      conns.push({
        source: { id: 4, position: "left" },
        destination: { id: 2, position: "left" }
      });
    }

    return (
      <Flowchart
        onChange={(nodes, connections) => {
          setNodes(nodes);
          setConns(connections);
        }}
        style={{ width: '100%', height: '100%' }}
        nodes={nodes}
        connections={conns}
      />
    );
  }

  return <>
    <ErrorAlert message={error} setMessage={setError} language={language} />
    <Row style={{ height: '100%' }}>
      <Col sm={4}><DataComponentWrapper componentType='list' layoutId="RfFlows" listRowSelected={listRowSelected} onObjUnderEditChanged={onObjUnderEditChanged} />
      </Col>
      <Col sm={3}>
        {createEdit()}
      </Col>
      <Col sm={4}>
        {createFlowChart()}
      </Col>
    </Row>
  </>
}
